(() => {
  const selector = '[data-juniper-love]';
  const revealSelector = [
    '.juniper-love__hero',
    '.juniper-love__intro',
    '.juniper-love__fit-image',
    '.juniper-love__fact',
    '.juniper-love__material-card',
    '.juniper-love__trust-item',
    '.juniper-love__faq',
  ].join(',');

  function mount(section) {
    if (!section || section.dataset.juniperLoveMounted === 'true') return;

    const button = section.querySelector('[data-juniper-love-more]');
    const clip = section.querySelector('[data-juniper-love-clip]');
    const buttonText = button?.querySelector('[data-juniper-love-button-text]');
    const moreContainer = button?.closest('.juniper-love__more');
    if (!button || !clip) return;

    section.dataset.juniperLoveMounted = 'true';
    const moreLabel = button.dataset.moreLabel || 'See more';
    const lessLabel = button.dataset.lessLabel || 'See less';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const revealItems = [...section.querySelectorAll(revealSelector)];
    revealItems.forEach((item, index) => {
      item.classList.add('juniper-love__reveal');
      if (
        item.classList.contains('juniper-love__hero') ||
        item.classList.contains('juniper-love__fit-image') ||
        item.classList.contains('juniper-love__material-card')
      ) {
        item.classList.add('juniper-love__reveal--image');
      }
      item.style.setProperty('--juniper-reveal-delay', `${(index % 5) * 70}ms`);
    });

    section.classList.add('is-reveal-ready');

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    } else {
      const revealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.14, rootMargin: '0px 0px -8% 0px' },
      );
      revealItems.forEach((item) => revealObserver.observe(item));
    }

    const setExpanded = (expanded) => {
      section.classList.toggle('is-expanded', expanded);
      button.setAttribute('aria-expanded', String(expanded));
      if (buttonText) buttonText.textContent = expanded ? lessLabel : moreLabel;
      moreContainer.hidden = false;
    };

    const updateButton = () => {
      const needsExpansion = clip.scrollHeight > clip.clientHeight + 4;
      moreContainer.hidden = !needsExpansion;
      section.classList.toggle('is-expanded', !needsExpansion);
      button.setAttribute('aria-expanded', String(!needsExpansion));
      if (buttonText) buttonText.textContent = needsExpansion ? moreLabel : lessLabel;
    };

    button.addEventListener('click', () => {
      const isExpanded = section.classList.contains('is-expanded');
      if (!isExpanded) {
        setExpanded(true);
        return;
      }

      setExpanded(false);
      const sectionTop = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: Math.max(0, sectionTop - 20),
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    });

    if (document.readyState === 'complete') updateButton();
    else window.addEventListener('load', updateButton, { once: true });
  }

  function init(root = document) {
    if (root.matches?.(selector)) mount(root);
    root.querySelectorAll?.(selector).forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
